import React, { forwardRef, useEffect, useState } from 'react';
import { Input, InputRef } from 'antd';

interface InputComponentProps {
  allowClear?: boolean,
  value?: any,
  onChange?: any,
  selectAfter?: React.JSX.Element
}

const Index = forwardRef<InputRef, InputComponentProps>(
  ({ allowClear, value, onChange, selectAfter }, ref) => {
    const [inputValue, setInputValue] = useState<string>('0');


    useEffect(() => {
      setInputValue(value || '0');
    }, [value]);

    const handleBlur = () => {
      let valueTemp = String(inputValue);
      if (inputValue === '') {
        setInputValue('0');
      }
      onChange(valueTemp);
    };

    const handleClick = (e: React.MouseEvent<HTMLInputElement>) => {
      if (e.currentTarget.value === '0') {
        setInputValue('');
      }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setInputValue(e.target.value);
    };

    return (
      <Input
        addonAfter={selectAfter}
        ref={ref}
        allowClear={allowClear}
        value={inputValue}
        onClick={handleClick}
        onBlur={handleBlur}
        onChange={handleChange}
      />
    );
  },
);

export default Index;